<template>
  <div class="divButtonsTop">
    <div :class="(classGrid !== '') ? classGrid + ' divButtonsBottom' : 'divButtonsBottom'">
      <ButtonSubmit
        v-for="(button, index) in buttonsList"
        :key="index"
        :button="button"
        :style-value="styleValueButtons"
        :class-name="classNameButtons"
        :text="button.text"
        type="notDefault"
        @submitButton="$emit('update-input', (button.value) ? button.value : button.text)"
      />
    </div>
  </div>
</template>

<script>

import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";

export default {
  name: "ButtonForLoop",
  components: {
    ButtonSubmit,
  },
  props: {
    buttonsList : {
      type: Array,
      default: () => {},
    },
    styleValueButtons: {
      type: String,
      default: "",
    },
    classNameButtons: {
      type: String,
      default: "",
    },
    classGrid: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.divButtonsBottom{
  display: grid !important;
  grid-gap: 10px !important;
  overflow: auto !important;
  max-height: 250px !important;
}

.divButtonsBottom.grid-4{
  grid-template-columns: repeat(4, 1fr) !important;
}

.divButtonsBottom.grid-3{
  grid-template-columns: repeat(3, 1fr) !important;
}
.divButtonsBottom.grid-5{
  grid-template-columns: repeat(5, 1fr) !important;
}

.divButtonsBottom.grid-2{
  grid-template-columns: repeat(2, 1fr) !important;
  grid-column-gap: 50px !important;
  width: max-content !important;
  margin: auto;
}

.divButtonsBottom.grid-2 .validateButtonSubmitNoo-cleed{
  width: 50px !important;
  margin: 0 auto !important;
}
</style>
```
